import angular from 'angular';
import template from './rw-tooltip.html';

// eslint-disable-next-line no-undef
@Inject('$element', '$scope', '$transclude')
class RwTooltipController {
  constructor() {
    this.side = this.side || 'left';
    this.isSmart = this.isSmart !== undefined ? this.isSmart : true;
    this.isSlotFilled = this.$transclude.isSlotFilled('rwTooltipContent');
  }

  $postLink() {
    this.$scope.$applyAsync(() => {
      this.info = angular.element(this.$element[0]).find('rw-tooltip-text')[0].innerText;
    });
  }
}

export default class RwTooltipComponent {
  constructor() {
    this.bindings = {
      side: '@',
      isSmart: '<',
    };
    this.transclude = {
      rwTooltipText: '?rwTooltipText',
      rwTooltipContent: '?rwTooltipContent',
    };
    this.controller = RwTooltipController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-tooltip/rw-tooltip-component.js